var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    _vm._l(_vm.items, function (item) {
      return _c(
        "li",
        {
          key: item.teamId,
          staticClass:
            "d-table w-100-p b-b b-c-g-100 cursor-default bg-g-50-hover",
          on: {
            click: function ($event) {
              !_vm.showSelectedStatus && _vm.itemClickEvent(item)
            },
          },
        },
        [
          (!_vm.value ||
            (_vm.value && item.name && item.name.includes(_vm.value))) &&
          !item.name.includes("圆捷群")
            ? _c(
                "div",
                {
                  staticClass:
                    "d-table w-100-p h-67 b-b b-c-g-100 cursor-default bg-g-50-hover p-relative",
                },
                [
                  item.serverCustom && item.avatar !== "N"
                    ? _c(
                        "div",
                        {
                          staticClass: "d-table-cell v-a-middle h-100-p w-64",
                          staticStyle: { "text-align": "center" },
                        },
                        [
                          item.avatar
                            ? _c("img", {
                                staticStyle: { width: "40px", height: "40px" },
                                attrs: { src: item.avatar },
                              })
                            : _c("img", {
                                staticStyle: { width: "40px", height: "40px" },
                                attrs: {
                                  src: require("@/assets/images/im/zhuanShu@2x.png"),
                                },
                              }),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass:
                            "d-table-cell v-a-middle h-100-p w-64 t-a-center",
                        },
                        [
                          _c("img", {
                            staticStyle: { width: "40px", height: "40px" },
                            attrs: {
                              src: require("@/assets/images/im/team-cus.png"),
                            },
                          }),
                        ]
                      ),
                  _c(
                    "div",
                    { staticClass: "d-table-cell v-a-middle h-100-p" },
                    [
                      _c("div", { style: { width: _vm.listWidth + "px" } }, [
                        _c(
                          "p",
                          { staticClass: "t-ellipsis l-h-1-6-em m-r-10" },
                          [_vm._v(_vm._s(item.name))]
                        ),
                      ]),
                    ]
                  ),
                  _vm.showSelectedStatus
                    ? [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedSessionsID,
                              expression: "selectedSessionsID",
                            },
                          ],
                          staticClass:
                            "p-absolute top-0 right-0 bottom-0 left-0 o-0 w-100-p h-100-p",
                          attrs: { name: "Fruit", type: "checkbox" },
                          domProps: {
                            value: item.teamId,
                            checked: Array.isArray(_vm.selectedSessionsID)
                              ? _vm._i(_vm.selectedSessionsID, item.teamId) > -1
                              : _vm.selectedSessionsID,
                          },
                          on: {
                            change: [
                              function ($event) {
                                var $$a = _vm.selectedSessionsID,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = item.teamId,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectedSessionsID = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectedSessionsID = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectedSessionsID = $$c
                                }
                              },
                              function ($event) {
                                return _vm.onSelectedSessionChange(item)
                              },
                            ],
                          },
                        }),
                        _vm.selectedSessionsID.includes(item.teamId)
                          ? _c("i", { staticClass: "d-inline-block m-t-22" }, [
                              _c("img", {
                                staticStyle: { width: "22px", height: "22px" },
                                attrs: {
                                  src: require("@/assets/images/im/selectedSession@2x.png"),
                                },
                              }),
                            ])
                          : _c("i", { staticClass: "d-inline-block m-t-22" }, [
                              _c("img", {
                                staticStyle: { width: "22px", height: "22px" },
                                attrs: {
                                  src: require("@/assets/images/im/unSelectedSession@2x.png"),
                                },
                              }),
                            ]),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }